import React, { useEffect, useState, useRef } from 'react';
const values = [{
  illustration: 'https://cdn.magicpatterns.com/uploads/oKyNAJsstThAt61qq4DezA/adapt_to_reality.png',
  title: 'Adapt to reality',
  description: "Product development isn't linear. We navigate trade-offs, focus on what matters most, and ensure design accelerates your R&D team.",
  color: 'var(--text)'
}, {
  illustration: 'https://cdn.magicpatterns.com/uploads/9ZwxG3Vf95BCgQJrhjm5QW/start_with_the_user.png',
  title: 'Start with the user',
  description: 'We ground every decision in user behavior and data. Usability leads. Aesthetics follow.',
  color: 'var(--text)'
}, {
  illustration: 'https://cdn.magicpatterns.com/uploads/4HzWAUsXZQmivgidjGDTFn/design_as_owners.png',
  title: 'Design as owners',
  description: 'We immerse ourselves in your mission, product, and team. We design within real constraints and hand off work built for execution.',
  color: 'var(--text)'
}];
export function Values() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return <section className="py-24 px-6 border-t border-b" style={{
    backgroundColor: 'var(--bg)',
    borderColor: 'var(--border)'
  }} data-id="element-51">
      <div className="max-w-6xl mx-auto" data-id="element-52">
        <div ref={ref} className="mb-16 transition-all duration-700 ease-out" style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(16px)'
      }} data-id="element-53">
          <h2 style={{
          color: 'var(--text)',
          fontFamily: 'var(--font-heading)',
          fontSize: 'var(--text-heading)',
          fontWeight: 'normal'
        }} data-id="element-54">
            Our values
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-55">
          {values.map((value, i) => <ValueCard key={value.title} value={value} index={i} parentVisible={visible} data-id="element-56" />)}
        </div>
      </div>
    </section>;
}
function ValueCard({
  value,
  index,
  parentVisible
}: {
  value: (typeof values)[0];
  index: number;
  parentVisible: boolean;
}) {
  const illustrationHeight = index === 2 ? 90 : 132;
  return <div className="flex flex-col transition-all duration-700 ease-out" style={{
    opacity: parentVisible ? 1 : 0,
    transform: parentVisible ? 'translateY(0)' : 'translateY(24px)',
    transitionDelay: `${index * 120 + 200}ms`
  }} data-id="element-57">
      <div className="mb-8 flex items-center justify-start" style={{
      height: '132px'
    }} data-id="element-58">
        <img src={value.illustration} alt={value.title} style={{
        height: `${illustrationHeight}px`,
        width: 'auto',
        objectFit: 'contain'
      }} data-id="element-59" />
      </div>
      <div className="pt-8 border-t" style={{
      borderColor: 'var(--border)'
    }} data-id="element-60">
        <h3 className="mb-3" style={{
        color: value.color,
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-title)',
        fontWeight: '600'
      }} data-id="element-61">
          {value.title}
        </h3>
        <p className="leading-relaxed" style={{
        color: 'var(--text-muted)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-body)',
        fontWeight: '400'
      }} data-id="element-62">
          {value.description}
        </p>
      </div>
    </div>;
}